import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../assets/page-image/stsg/banner.png';
import _imports_1 from '../assets/page-image/stsg/erweima.png';
const _hoisted_1 = {
  class: "stsg-wrapper"
};
const _hoisted_2 = {
  class: "stsg-page"
};
const _hoisted_3 = {
  class: "main-content"
};
const _hoisted_4 = {
  class: "left-section"
};
const _hoisted_5 = {
  class: "book-types"
};
const _hoisted_6 = {
  class: "book-color"
};
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = {
  class: "book-name"
};
const _hoisted_9 = {
  class: "right-section"
};
const _hoisted_10 = {
  class: "info-card"
};
const _hoisted_11 = {
  key: 0,
  class: "info-title"
};
const _hoisted_12 = {
  key: 1,
  class: "info-content"
};
const _hoisted_13 = {
  class: "section"
};
const _hoisted_14 = {
  class: "certificate-images"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "section"
};
const _hoisted_17 = {
  key: 0,
  class: "environment-images"
};
const _hoisted_18 = {
  class: "env-left"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "env-right"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
import { ref, computed, onMounted } from 'vue';
import SectionTitle from '@/components/SectionTitle.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Footer from '@/components/Footer.vue';
import { getProvincialBookStationInfo } from '@/api/bookstation';
// 省图书驿站信息数据
export default /*@__PURE__*/_defineComponent({
  __name: 'Stsg',
  setup(__props) {
    const bookStationInfo = ref({
      environment: [],
      bookTypeList: [],
      documentPhotoList: [],
      openTimeAndTel: []
    });
    // 获取开放时间
    const openTime = computed(() => {
      const item = bookStationInfo.value.openTimeAndTel?.find(item => item.key === '开放时间');
      return item?.value || '';
    });
    // 获取联系方式
    const contactPhone = computed(() => {
      const item = bookStationInfo.value.openTimeAndTel?.find(item => item.key === '联系方式');
      return item?.value || '';
    });
    // 获取省图书驿站信息
    const fetchBookStationInfo = async () => {
      try {
        const res = await getProvincialBookStationInfo();
        if (res.code === 200) {
          bookStationInfo.value = res.data;
          // console.log('省图书驿站信息:', bookStationInfo.value);
        }
      } catch (error) {
        console.error('获取省图书驿站信息失败:', error);
      }
    };
    // 页面加载时获取数据
    onMounted(() => {
      fetchBookStationInfo();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '技术服务平台'
        }, {
          label: '省图书驿站'
        }]
      }), _createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "省图书馆"
      })], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(SectionTitle, {
        title: "图书类型",
        "show-more": false
      }), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookStationInfo.value.bookTypeList, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "book-card",
          key: item.id
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: item.url,
          alt: item.name
        }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)]);
      }), 128))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [openTime.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, "开放时间：" + _toDisplayString(openTime.value), 1)) : _createCommentVNode("", true), contactPhone.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, "联系方式：电话：" + _toDisplayString(contactPhone.value), 1)) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "info-button"
      }, [_createElementVNode("button", {
        class: "contact-btn"
      }, "联系我们")], -1))])])]), _createElementVNode("div", _hoisted_13, [_createVNode(SectionTitle, {
        title: "证件",
        "show-more": false
      }), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookStationInfo.value.documentPhotoList, item => {
        return _openBlock(), _createElementBlock("img", {
          key: item.id,
          src: item.url,
          alt: "证件"
        }, null, 8, _hoisted_15);
      }), 128))])]), _createElementVNode("div", _hoisted_16, [_createVNode(SectionTitle, {
        title: "环境",
        "show-more": false
      }), bookStationInfo.value.environment && bookStationInfo.value.environment.length >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
        src: bookStationInfo.value.environment[0].url,
        alt: "环境1"
      }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
        src: bookStationInfo.value.environment[1].url,
        alt: "环境2"
      }, null, 8, _hoisted_21), _createElementVNode("img", {
        src: bookStationInfo.value.environment[2].url,
        alt: "环境3"
      }, null, 8, _hoisted_22)])])) : _createCommentVNode("", true)]), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "qrcode-section"
      }, [_createElementVNode("img", {
        src: _imports_1,
        alt: "二维码"
      })], -1))]), _createVNode(Footer)]);
    };
  }
});